import type { AnalyticsData } from "../types";
import { webEvent } from "./event";

const event = (name: string, data?: AnalyticsData) => webEvent("onboarding", name, data);

// First event in pi-web while creating an onboarding session (after user registers in pi-admin)
export const onboardingStarted = () => event("started");

export const onboardingPresetSelected = (presetId: string) =>
  event("preset_selected", { presetId });

export const onboardingPresetConfirmed = (presetId: string) =>
  event("preset_confirmed", { presetId });

export const onboardingSessionCreated = (
  teamCount: number,
  iterationCount: number,
  presetId: string,
) => event("session_created", { teamCount, iterationCount, presetId });

export const onboardingSessionCreationFailed = (presetId: string) =>
  event("session_creation_failed", { presetId });

export const onboardingMobileGateShown = () => event("mobile_gate_shown");

export const onboardingCardClicked = (cardName: string) =>
  event("guide_card_clicked", { cardName });

export const onboardingContactClicked = () => event("guide_contact_clicked");

export const onboardingGuideDismissed = () => event("guide_dismissed");

export const welcomeVideoShown = (isReplay: boolean) => event("welcome_video_shown", { isReplay });

export const welcomeVideoCompleted = (isReplay: boolean) =>
  event("welcome_video_completed", { isReplay });

export const welcomeVideoSkipped = (currentTime: number, duration: number) =>
  event("welcome_video_skipped", {
    currentTime: Math.round(currentTime),
    duration: Math.round(duration),
  });

export const welcomeVideoReplayed = () => event("welcome_video_replayed");

export const onboardingGuideShown = (isFirstTime: boolean) => event("guide_shown", { isFirstTime });

export const onboardingGuideOpened = () => event("guide_opened");

export const onboardingCompleted = () => event("completed");
